import { Link } from "react-router-dom";
import {
  Shirt, Smartphone, Sofa, Sparkles, Utensils, Car,
  Briefcase, Home, Building2, Baby, Dumbbell, Package,
} from "lucide-react";

const ICONS = { shirt: Shirt, smartphone: Smartphone, sofa: Sofa, sparkles: Sparkles, utensils: Utensils, car: Car, briefcase: Briefcase, home: Home, "building-2": Building2, baby: Baby, dumbbell: Dumbbell, package: Package };

export default function CategoryChips({ categories }) {
  return (
    <div className="px-3 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-1 -mx-1 px-1">
          {categories.map((c) => {
            const Icon = ICONS[c.icon] || Package;
            return (
              <Link
                key={c.slug}
                to={`/recherche?category=${c.slug}`}
                data-testid={`cat-${c.slug}`}
                className="shrink-0 flex flex-col items-center gap-1.5 px-3 pt-3 pb-2 rounded-xl bg-white border border-[#E8E6E1] hover:border-[#E65100] hover:bg-[#FFF8F3] transition w-20 sm:w-24"
              >
                <div className="w-10 h-10 rounded-xl bg-[#FFF3E0] text-[#E65100] flex items-center justify-center">
                  <Icon className="h-5 w-5" />
                </div>
                <div className="text-[11px] text-center font-semibold text-[#1A1918] leading-tight line-clamp-2">{c.label}</div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
